import { signIn } from 'next-auth/react';
import { useState } from 'react';
import styles from './GoogleSignInButton.module.scss';

const GoogleSignInButton = ({ className = '', disabled = false, mode = 'signin' }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    setIsLoading(true);

    // Let NextAuth handle the redirect naturally
    await signIn('google', {
      callbackUrl: '/account/dashboard',
    });
  };

  // Context-aware button text based on mode
  const buttonText = mode === 'signup' ? 'Sign up with Google' : 'Sign in with Google';

  // Official Google "G" logo SVG with exact brand colors
  const GoogleIcon = () => (
    <svg
      width="20"
      height="20"
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.googleIcon}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"
          fill="#4285f4"
        />
        <path
          d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"
          fill="#34a853"
        />
        <path
          d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"
          fill="#fbbc05"
        />
        <path
          d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"
          fill="#ea4335"
        />
      </g>
    </svg>
  );

  return (
    <button
      type="button"
      onClick={handleGoogleSignIn}
      disabled={disabled || isLoading}
      className={`${styles.googleSignInButton} ${className}`}
      aria-label="Sign in with Google"
    >
      <span className={styles.googleSignInIcon}>
        <GoogleIcon />
      </span>
      <span className={styles.googleSignInText}>
        {isLoading ? (mode === 'signup' ? 'Signing up...' : 'Signing in...') : buttonText}
      </span>
    </button>
  );
};

export default GoogleSignInButton;
